<div class="primary-cta" [class.highlight-total]="highlightTotal() && delimiter() === 'and'">
@if (canRedeemPoints() && ((price() && points()) || showBoth())) {
        <span class="price">{{ price() | currency }}</span>
        <span class="body-0"> {{ delimiter() }} </span>
        <span class="points">{{ points() | appDigitsGrouping }} pts</span>
    } @else if (price()) {
    <span class="price">{{ price() | currency }}</span>
    } @else if (points() && canRedeemPoints()) {
    <span class="points">{{ points() | appDigitsGrouping }} pts</span>
    }
</div>
